
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z' fill='#323232'/><path d='M19 11.9C19 11.41 18.64 11.01 18.16 10.93C16.91 10.72 15.73 10.05 14.93 9.17001L13.64 7.74001C13.47 7.55001 13.26 7.40001 13.03 7.29001C13.02 7.29001 13.02 7.28001 13.01 7.28001H13C12.63 7.07001 12.22 6.97001 11.75 7.03001C10.73 7.15001 10 8.07001 10 9.10001V15C10 16.1 10.9 17 12 17H17V21C17 21.55 17.45 22 18 22C18.55 22 19 21.55 19 21V16.5C19 15.4 18.1 14.5 17 14.5H14V11.05C15 11.88 16.4 12.59 17.8 12.87C18.42 13 19 12.53 19 11.9ZM12.83 18C12.42 19.16 11.31 20 10 20C8.34 20 7 18.66 7 17C7 15.69 7.84 14.59 9 14.17V12.1C6.72 12.56 5 14.58 5 17C5 19.76 7.24 22 10 22C12.42 22 14.44 20.28 14.9 18H12.83Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-accessible`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconAccessible

    ```js
    <b-new-b-icon-accessible />
    ```
</docs>


